import { axiosApi } from '@/config';
import { StateResponseData } from '@/interfaces';

export const getAllState = async (): Promise<StateResponseData> => {
	try {
		const response = await axiosApi.get(`/state`);
		return response.data;
	} catch (error) {
		console.error('Error fetching products:', error);
		throw error;
	}
};
